import React__default from 'react';
import '../../utils/index.js';
import { PortalTargetProvider } from './PortalTargetContext.js';
import { conditionalA11yHelpersWrapper } from './A11yHelpersContext.js';
import { TranslationProvider } from '../../utils/Translation/TranslationProvider.js';

const UIProviderInner = _ref => {
  let {
    children,
    portalTarget,
    config = {}
  } = _ref;
  return /*#__PURE__*/React__default.createElement(TranslationProvider, {
    localizedText: config === null || config === void 0 ? void 0 : config.localizedText
  }, /*#__PURE__*/React__default.createElement(PortalTargetProvider, {
    target: portalTarget !== null && portalTarget !== void 0 ? portalTarget : null
  }, children));
};
const UIProvider = conditionalA11yHelpersWrapper(UIProviderInner, 'both');

export { UIProvider, UIProviderInner };
